/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global ScrollMagic, TweenMax, TimelineMax, Linear */

const shapesParallax = {
  controller: new ScrollMagic.Controller(),
  init: function() {
    document.querySelectorAll('.home-shapes').forEach( (shapesArea) => {
      let tweens = [];
      let imageTranslations = ["-39vw", "15vw", "-22vw"];

      let i = 0;
      shapesArea.querySelectorAll('img').forEach((shape) => {
          tweens.push(
              TweenMax.to(shape, 1, {y:imageTranslations[i], ease: Linear.easeNone})
          );
          i++;
      });
      var tween = new TimelineMax()
          .add([
              tweens,
          ]);
      new ScrollMagic.Scene({triggerElement: shapesArea, triggerHook: "0", duration: "200%"})
          .setTween(tween)
          .addTo(this.controller);
    });
  },
};

export default shapesParallax;

